export default "__VITE_ASSET__BCpYMmeF__"